import { useEffect, useMemo, useState } from 'react'

export interface UseSyncedShortlistOptions<T extends { id: number }> {
  query: { id?: number | null; page?: number | null }
  setQuery: (params: Partial<{ id: number; page: number }>, mode?: 'replaceIn' | 'pushIn') => void
  tabs: T[]
  isFetching: boolean
  userId?: number | string
  tablePage: number
  setTablePage: (page: number) => void
}

export function useSyncedShortlist<T extends { id: number }>(
  options: UseSyncedShortlistOptions<T>,
): [number | undefined, React.Dispatch<React.SetStateAction<number | undefined>>] {
  const { query, setQuery, tabs, isFetching, userId, tablePage, setTablePage } = options
  const [activeShortlistId, setActiveShortlistId] = useState<number>()

  const shortlistIdFromQuery = useMemo(() => {
    return query.id && tabs.some(tab => tab.id === query.id) ? query.id : null
  }, [query.id, tabs])

  useEffect(() => {
    if (isFetching || !userId || tabs.length === 0) {
      return
    }

    const idToSet = shortlistIdFromQuery ?? tabs[0]!.id
    const pageToSet = shortlistIdFromQuery ? tablePage : 1

    setActiveShortlistId(idToSet)
    setQuery({ id: idToSet, page: pageToSet })

    if (!shortlistIdFromQuery && tablePage !== 1) {
      setTablePage(1)
    }
  }, [isFetching, userId, tabs, shortlistIdFromQuery, tablePage, setQuery, setTablePage])

  return [activeShortlistId, setActiveShortlistId]
}
